import React, { ReactElement, useEffect } from 'react';
import { matchPath, useLocation, useNavigate } from 'react-router';

import { UserDataState } from '@/components/AppInitializer/types';
import { allRoutes } from '../config';
import PermissionsGuard from './PermissionsGuard';

function AuthGuard({ children, ...routeProps }): ReactElement {
  const navigate = useNavigate();
  const location = useLocation();
  const { userDataState, userLoggedIn } = routeProps;

  const getRedirection = () => {
    const pathname = location?.pathname || '';
    if (pathname === '/' || pathname === '/login') return '';
    const currentPathValid = allRoutes.some(({ path }) => !!matchPath({ path, end: false }, pathname));
    return currentPathValid ? `?redirectTo=${pathname}` : '';
  };

  useEffect(() => {
    const isLoading = userDataState === UserDataState.LOADING;
    if (!userLoggedIn && !isLoading && location.pathname !== '/login' && location.pathname !== '/') {
      navigate(`/login${getRedirection()}`, { replace: true });
    }
  }, [userLoggedIn, userDataState, location.pathname, navigate]);

  return <PermissionsGuard {...routeProps}>{children}</PermissionsGuard>;
}

export default AuthGuard;
